import { getDeposit } from "../api/api";
import { SequenceManagerAction } from '../actions/SequenceManagerAction';

const SecurityDepositAction = {
    FETCH_SECURITY_DEPOSIT_SUCCESS : 'FETCH_SECURITY_DEPOSIT_SUCCESS',
    FETCH_SECURITY_DEPOSIT_FAILURE : 'FETCH_SECURITY_DEPOSIT_FAILURE',
    SECURITY_DEPOSIT_ACCEPTED : 'SECURITY_DEPOSIT_ACCEPTED'
} as const;

const fetchSecurityDeposit = (personId: any, bandWidth: any) => {
    return function (dispatch: any) {
        getDeposit(personId, bandWidth)
            .then((response) => {
                dispatch({ type: SecurityDepositAction.FETCH_SECURITY_DEPOSIT_SUCCESS, payload: response.data });
            })
            .catch((err) => {
                //Display error
                const config = Object.assign(err?.config, { serviceName: 'securityDeposit' });
                const error = { ...err, config };

                dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
            })
    }
}

const acceptSecurityDeposit = (securityDepositResponse: any, offerContainerId: any) => {
    return function (dispatch: any) {
        dispatch({ type: SecurityDepositAction.SECURITY_DEPOSIT_ACCEPTED, payload: { securityDepositResponse: securityDepositResponse, offerContainerId: offerContainerId } });
        dispatch({ type: SequenceManagerAction.SECTION_COMPLETE, payload: ['SecurityDeposit'] });
    }
}


export { SecurityDepositAction, fetchSecurityDeposit, acceptSecurityDeposit };